import { CommerceService } from "@/services/commerce"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getCustomer } from "../../shared/utils/getCustomer"

export const mutationClearPicklistEditingMode = {
  async clearPicklistEditingMode(parent, args, context, info) {
    let { customerId, customerNumber, cartId } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.CARTS,
      operation: Operations.UPDATE,
    })
    if (!customerId || !cartId) {
      throw new Error("Missing data")
    }

    const customer = await getCustomer({ id: customerId, number: customerNumber })

    if (!customer) {
      throw new Error("Customer not found")
    }

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })

    const commerceApi = CommerceService.api()

    // Get current cart
    const currentCart = (await commerceApi.carts().withId({ ID: cartId }).get().execute()).body

    if (!currentCart) {
      throw new Error("Cart not found")
    }

    // Clear picklist editing mode custom fields
    // Picklist editing mode is determined by picklistNumber, so we clear it
    const actions = [{ action: "setCustomField", name: "picklistNumber", value: null }]

    // Execute actions with one retry on version conflict
    const postActions = async (id, version, actions) => {
      return await commerceApi.carts().withId({ ID: id }).post({ body: { version, actions } }).execute()
    }

    try {
      const updatedCart = await postActions(cartId, currentCart.version, actions)
      return updatedCart.body
    } catch (error) {
      const message = error?.message || ""
      if (message.includes("different version than expected") || message.includes("ConcurrentModification")) {
        const latest = (await commerceApi.carts().withId({ ID: cartId }).get().execute()).body
        const retried = await postActions(cartId, latest.version, actions)
        return retried.body
      }
      throw error
    }
  },
}
